"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LookFilter = void 0;
const baseFilter_1 = require("./baseFilter");
class LookFilter extends baseFilter_1.BaseFilter {
    constructor(id, lookId, name, type, defaultValue, model, explore, dimension) {
        super(id, name, type, defaultValue, model, explore, dimension);
        this.lookId = lookId;
        this.defaultValues = defaultValue?.split(',');
    }
}
exports.LookFilter = LookFilter;
